import { Tooltip } from 'react-tooltip';

import Toolbar from '@components/toolbar/Toolbar';

/**
 * The toolbar in the map editor page. It contains all functionality to interact with the map and the annotations on it.
 */

const MapToolbar = ({ children }) => {
	return (
		<Toolbar>
			{children}
			<Tooltip id="tooltip-toolbar-root" variant="light" />
		</Toolbar>
	);
};

export default MapToolbar;
